import { trackCioEvent } from '../cio';
import { identifyUser } from '../identifyUser';
import { AnalyticsEvent } from '../types';

export type InputPayorsAndZipEventProperties = {
  email: string;
  insurance_types: string[];
  insurance_zipcode: string;
};

export function trackInputPayorsAndZip(properties: InputPayorsAndZipEventProperties) {
  if (properties.email) {
    void identifyUser(properties.email, {
      insuranceTypes: properties.insurance_types,
      insuranceZipcode: properties.insurance_zipcode,
    });
  }

  // TODO: Deprecate this event after campaign is removed:
  // https://linear.app/conduithealth/issue/ENG-1604/dtc-cio-campaign-input-payors-and-zip-campaign
  trackCioEvent(AnalyticsEvent.INPUT_PAYORS_AND_ZIP, properties);
}
